/* global angular */
( function () {
	'use strict';

	function ManageShareControlsCtrl () {
		var self = this;
		var stateActions;

		function activate () {
			stateActions = [ 'remove', 'add', 'block' ];
		}

		function toggle ( parentState, overrideState ) {
			self.state     = overrideState || ( self.state + 1 ) % 3;
			self.inherited = false;
			self.onToggle( {
				'action'    : stateActions[ self.state ],
				'id'        : self.recipientId,
				'privilege' : self.privilege,
				'modelType' : self.modelType
			} );

			// when state is 0 [ remove ], set back to parent state
			if ( !self.state ) {
				self.inherited = true;
				self.state     = parentState;
			}
		}

		self.toggle = toggle;

		activate();
	}

	angular
		.module( 'app.templates' )
		.controller( 'ManageShareControlsCtrl', ManageShareControlsCtrl );
} )( );
